import {
  Divider,
  Grid,
  PopperPlacementType,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';

import OperationResume from '../OperationResume';
import DocumentsTable from './components/DocumentsTable';
import PopperUniqueDate from './components/PopperUniqueDate';
import { DatesSelectorProps, DocumentWithDates } from './types';

const DatesSelector = (props: DatesSelectorProps) => {
  const {
    selectedDocuments,
    setSelectedDocuments,
    canForcePaymentDate,
    minimumDays,
    maximumDays,
    operationDate,
    setOperationDate,
    business,
    productType,
    operationDateDate,
    setOperationDateDate,
  } = props;

  const [showUniqueDate, setShowUniqueDate] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );
  const [placement, setPlacement] =
    React.useState<PopperPlacementType>('right');

  const handleClickPopperUniqueDate =
    (newPlacement: PopperPlacementType) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setShowUniqueDate((prev) => placement !== newPlacement || !prev);
      setPlacement(newPlacement);
    };

  const resetSelectedDocumentsDates = () => {
    setSelectedDocuments(
      selectedDocuments.map((doc: DocumentWithDates) => ({
        ...doc,
        dueDate: undefined,
        paymentDate: undefined,
        tempDueDate: '',
        daysToCount: undefined,
      })),
    );
  };

  return (
    <div>
      <OperationResume
        stakeholderName={business.businessName}
        stakeholderIdentifier={business.identifier}
        documents={selectedDocuments}
        productType={productType}
      />
      <Divider />
      <div style={{ padding: '20px 0px' }}>
        <Typography variant="h6">Selecciona la fecha de operación.</Typography>
        <div style={{ marginTop: 10 }}>
          <TextField
            id="outlined-basic-two"
            label="Fecha de operación"
            variant="outlined"
            type="date"
            value={operationDate}
            fullWidth
            onChange={(e) => {
              setOperationDate(e.target.value);
              setOperationDateDate(new Date(e.target.value));
              resetSelectedDocumentsDates();
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography padding="0px 0px 8px" variant="h6">
          Documentos seleccionados:
        </Typography>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                padding="4px 0px 0px 10px"
                variant="body1"
                textAlign="right"
                fontWeight="bold"
                style={{ cursor: 'pointer' }}
                onClick={handleClickPopperUniqueDate('right-start')}
                color="primary"
              >
                Fecha única
              </Typography>
            </Grid>
          </Grid>
        </div>
      </div>
      <PopperUniqueDate
        open={showUniqueDate}
        setOpen={setShowUniqueDate}
        selectedDocuments={selectedDocuments}
        setSelectedDocuments={setSelectedDocuments}
        anchorEl={anchorEl}
        handleClickPopper={handleClickPopperUniqueDate}
        placement={placement}
        canForcePaymentDate={canForcePaymentDate}
        minimumDays={minimumDays}
        maximumDays={maximumDays}
        operationDate={operationDateDate}
      />
      <DocumentsTable
        selectedDocuments={selectedDocuments}
        setSelectedDocuments={setSelectedDocuments}
        canForcePaymentDate={canForcePaymentDate}
        minimumDays={minimumDays}
        maximumDays={maximumDays}
        operationDate={operationDateDate}
      />
    </div>
  );
};

export default DatesSelector;
